import { userConstants } from "../constants/login.constants";

function companySignedDocuments(state = {}, action) {
    switch (action.type) {
        case userConstants.SIGNEDDOCUMENTS_REQUEST:
            return {
                loading: true,
                ...state,
            };
        case userConstants.SIGNEDDOCUMENTS_SUCCESS:
            return {
                items: action.companySignedDocuments
            };
        case userConstants.SIGNEDDOCUMENTS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state;
    }
}

export default companySignedDocuments;